import React, { Component } from 'react'
import LoaderDots from '../loaderDots'
import { isMobileOnly } from 'react-device-detect'
import AcademyDetailsModal from '../Academies/AcademyDetailsModal'

class List extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedAcademy: null,
    }
  }

  selectAcademy(academy) {
    this.setState({ selectedAcademy: academy })
  }

  desktopRowsList() {
    const { academies } = this.props

    return academies.map((academy, index) => {
      return (
        <tr key={index}>
          <td className="name bg-lighter">{academy.name}</td>
          <td className="country bg-darker">{academy.country}</td>
          <td
            className="details text-center bg-lighter"
            data-toggle="modal"
            data-target="#academy-details"
            onClick={() => this.selectAcademy(academy)}
          >
            <span className="icon">
              <i className="fa fa-info-circle"></i>
            </span>
          </td>
        </tr>
      )
    })
  }

  mobileRowsList() {
    const { academies } = this.props

    return academies.map((academy, index) => {
      return (
        <React.Fragment key={index}>
          <tr key={index}>
            <td className="name bg-lighter">{academy.name}</td>
            <td className="country bg-darker">{academy.country}</td>
            <td
              className="details text-center bg-lighter"
              data-toggle="modal"
              data-target="#academy-details"
              onClick={() => this.selectAcademy(academy)}
            >
              <span className="icon">
                <i className="fa fa-info-circle"></i>
              </span>
            </td>
          </tr>
        </React.Fragment>
      )
    })
  }

  rowsList() {
    return (
      <React.Fragment>
        {isMobileOnly ? this.mobileRowsList() : this.desktopRowsList()}
      </React.Fragment>
    )
  }

  render() {
    const { academies, loading, error, i18n, page } = this.props

    if (error) {
      console.log(error)

      return (
        <div className="search-failed">
          <h5>{i18n.t('academies.list.generalErrorMessage')}</h5>
          <h6>{i18n.t('academies.list.workingOn')}</h6>
        </div>
      )
    }

    if (!academies.length && !loading) {
      return (
        <div className="search-failed">
          <h5>{i18n.t('academies.list.notFoundMessage')}</h5>
          <h6>{i18n.t('academies.list.changeFilters')}</h6>
        </div>
      )
    }

    if (loading) return <LoaderDots />

    return (
      <div className="table-container">
        <table width="100%" id="academies-list">
          <thead>
            <React.Fragment>
              {isMobileOnly ? (
                <tr>
                  <th className="bg-primary">
                    {i18n.t('academies.list.name')}
                  </th>
                  <th className="bg-darker">
                    {i18n.t('academies.list.country')}
                  </th>
                  <th className="bg-primary">
                    {i18n.t('academies.list.details')}
                  </th>
                </tr>
              ) : (
                <tr>
                  <th className="bg-primary">
                    {i18n.t('academies.list.name')}
                  </th>
                  <th className="bg-darker">
                    {i18n.t('academies.list.country')}
                  </th>
                  <th className="bg-primary">
                    {i18n.t('academies.list.details')}
                  </th>
                </tr>
              )}
            </React.Fragment>
          </thead>
          <tbody>{this.rowsList()}</tbody>
        </table>

        <AcademyDetailsModal
          academy={this.state.selectedAcademy}
          i18n={i18n}
          page={page}
        />
      </div>
    )
  }
}

export default List
